export const API_HOST = process.env.REACT_APP_API_URL || 'https://prod-api-sheffmed.ontheappt.cloud'
export const ORG_ID = '05a679f7-5e3a-4b6f-bd39-238cd9e22312'

console.log('API_HOST', API_HOST)

// stage
export const DEFAULT_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI4NzBmOGE4OS0yYjEyLTQwZGQtYmE4Ny00MGM5MjNkN2Y3ZjkiLCJpYXQiOjE3MzcwMTMxOTUsImV4cCI6MTc2ODU3MDc5NX0.YHrhlN46xu9g6KHz2rYW1q4ANVSEcTx9QVGlKAuLhCc"

// localhost
// export const DEFAULT_TOKEN ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI4NzBmOGE4OS0yYjEyLTQwZGQtYmE4Ny00MGM5MjNkN2Y3ZjkiLCJpYXQiOjE3MzcwMzc4NjEsImV4cCI6MTc2ODU5NTQ2MX0.GC3VBfzl42en3UvdRIXrFmA9PP4QYy_RkN7GGXa7QjY"